export const generateRandomGUID = () => crypto.randomUUID();
